import consts from "@/consts"
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const changedField = 'changed__time';

export default {
    state: {
        trips_index: [],
        trips: [],
        trips_last_hour: [],
    },
    actions: {
        fetchTrips4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getTripsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchTrips4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastTrips', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchTripsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('trips', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.trips.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeTrips', response.data)
                            commit('setTripsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                dispatch('fetchTripsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                response.data
                                    .map(e => e.unit_id)
                                    .filter(arrayFilter_OnlyUnique)
                                    .forEach(unitId => {
                                        commit('setTripsIndex', {...args, unitId, count: 1})
                                    })
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTrips4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastTrips', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchTripsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchTrips4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getTripsIndex.find(i => (i.unit_id == args.unitId && ???))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchTrips4Date', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchTrips4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastTrips', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchTripsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('trips', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;delete params.force;
                this.$api.trips.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeTrips', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTrips4Date', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchTrips4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastTrips', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchTripsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchTripsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastTrips', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchTripsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchTrips4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastTrips', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchTripsChanged', args, inprogress: false})
                });
        },

        fetchTripsLastTime({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }
                let lmsg_time = getters.getUnitsLmsgsByIds[args.unitId]?.time || 0
                if (!(lmsg_time > getters.getTimeToday)) {
                    return resolve(true)
                }
                let today = getters.getDateToday
                //Index today
                let indx_today = getters.getTripsIndex.find(i => i.date == today && i.unitId == args.unitId)
                if (!indx_today) {
                    return resolve(true)
                }
                //trips&parkings time_end
                let time_ends = [
                    getters.getTripsMaxTimeEndByUnitsIds[args.unitId],
                    getters.getParkingsMaxTimeEndByUnitsIds[args.unitId]
                ].filter(t => !!t && t > 0)
                if (!time_ends.length) time_ends = [getters.getTimeToday]
                let time_start = Math.max(...time_ends)

                if (time_start > lmsg_time) {
                    console.warn('fetchTripsLastTime: Lmsg.time', {args, lmsg_time, time_start})
                    return resolve(true)
                }

                dispatch('setLastCall', {name: 'fetchTripsLastTime', args, time: Date.now() / 1000})

                let params = getApiProps('trips', {withAddress: 1, ...args, date: '', 'start-time': time_start})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.trips.getLast(args.unitId, '', params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeTripsLastHour', {unitId: args.unitId, time_start, data: response.data})
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTripsLastTime', args, inprogress: false})
                    });
            })
        },

        reloadTrips({commit, dispatch}, args) {
            commit('clearTrips')
            return dispatch('fetchTrips4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setTripsIndex(state, params) {
            let i = state.trips_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.trips_index.push(Object.freeze({...params}))
            } else {
                state.trips_index[i] = Object.freeze({...state.trips_index[i], ...params})
            }
        },
        storeTrips(state, nTrips) {
            nTrips = nTrips
                .filter(t => !state.trips.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
                //.map(t => Object.freeze(t))

            // if(nTrips.length) state.trips.push(...nTrips)
            if (!nTrips.length) return false
            if (!state.trips.length) {
                state.trips = nTrips
                return true
            }
            nTrips.forEach(function (nTrip) {
                let i = state.trips.findIndex(st => {
                    return st.unit_id == nTrip.unit_id
                        && st.time_start?.utc == nTrip.time_start?.utc
                        // && st.time_end?.utc == nTrip.time_end?.utc
                })
                if (i < 0) {
                    state.trips.push(Object.freeze(nTrip))
                } else
                if (state.trips[i][changedField] != nTrip[changedField])
                {
                    // updateObjectByDiff(state.trips[i], nTrip)
                    delete nTrip.unit_id;delete nTrip.time_start;
                    state.trips[i] = Object.freeze({...state.trips[i], ...nTrip})
                }
            })
        },

        storeTripsLastHour(state, args) {
            state.trips_last_hour = state.trips_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nTrips = args.data
            nTrips = nTrips
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.trips_last_hour.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
                //.map(t => Object.freeze(t))

            // if(nTrips.length) state.trips_last_hour.push(...nTrips)
            if (!nTrips.length) return false
            if (!state.trips_last_hour.length) {
                state.trips_last_hour = nTrips
                return true
            }
            nTrips.forEach(function (nTrip) {
                let i = state.trips_last_hour.findIndex(st => {
                    return st.unit_id == nTrip.unit_id
                        && st.time_start?.utc == nTrip.time_start?.utc
                        // && st.time_end?.utc == nTrip.time_end?.utc
                })
                if (i < 0) {
                    state.trips_last_hour.push(nTrip) //(Object.freeze(nTrip))
                } else
                {
                    updateObjectByDiff(state.trips_last_hour[i], nTrip)
                    // nTrip = {...state.trips_last_hour[i], ...nTrip}
                    // state.trips_last_hour[i] = nTrip //Object.freeze(nTrip)
                }
            })
        },

        clearTrips(state, {unitId} = {}) {
            if (unitId) {
                state.trips_last_hour = state.trips_last_hour.filter(t => (t.unit_id || t.object_id) != unitId)
                state.trips = state.trips.filter(t => (t.unit_id || t.object_id) != unitId)
                state.trips_index = state.trips_index.filter(i => i.unitId != unitId)
            } else {
                state.trips_last_hour = [];
                state.trips = [];
                state.trips_index = [];
            }
        },
    },
    getters: {
        getTripsIndex(state) {
            return state.trips_index
        },
        getTrips(state) {
            return [...state.trips, ...state.trips_last_hour]
        },
        getTripsMaxTimeEndByUnitsIds(state) {
            return state.trips.reduce((MaxTimeEndByUnitsIds, trip) => {
                if (+(trip?.time_end?.utc || 0) > +(MaxTimeEndByUnitsIds[trip.unit_id] || 0)) {
                    MaxTimeEndByUnitsIds[trip.unit_id] = trip?.time_end?.utc
                }
                return MaxTimeEndByUnitsIds
            }, {})
        },
    }
}
